import React from 'react';

interface FormItemProps {
    children: React.ReactNode;
    title?: string;
    required?: boolean;
    className?: string;
    variationClassName?: string;
    mode?: 'base' | 'lp';
}

const FormItem: React.FC<FormItemProps> = ({
    children,
    title,
    required,
    className = '',
    variationClassName = 'base',
    mode = 'base',
}) => {
    return (
        <div className={`form__input__base ${mode === 'lp' ? 'is-lp' : ''}`}>
            {title && (
                <b className={(required && mode === 'lp') ? 'is-lp-required' : ''}>
                    {(required && mode === 'base') && <i className="form__label">必須</i>}
                    <span>{title}</span>
                </b>
            )}
            <div
                className={`form__variation ${variationClassName} ${className}`}
            >
                {children}
            </div>
        </div>
    );
};

export default FormItem;
